import { useProduct } from '../ProductProvider';
import { useGlobal } from '@/utils/useGlobal';
import { generalKeys } from '../config/page';

export default function getProductMsg() {
    const { state, dispatch } = useProduct();
    if (state.productMsg && state.productMsg.length === generalKeys.length) return;
    const { gloproductlist } = useGlobal();
    let productMsgMap: any = {};
    generalKeys.map((generalKey: string) => {
        const target = gloproductlist?.find((item: any) => item.generalKey === generalKey);
        productMsgMap[generalKey] = target || {};
    });
    dispatch({
        type: 'changeProductMsg',
        payload: productMsgMap,
    });
}
